import React from 'react'
import { WithNavigation } from '@resiliatech/birdsong'
import { useAppNavigationProps } from './useAppNavigationProps'
import { useShowAppNavigation } from './useShowAppNavigation'
import { useNavigationPerfAnalytics } from './useNavigationPerfAnalytics'
import { useNavigationHeaderProps } from './useNavigationHeaderProps'

export const AppNavigationContainer = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const showAppNavigation = useShowAppNavigation()
  const { platformPlan, orgName, logo, isFunder } = useNavigationHeaderProps()
  const { navItems, accountItems, activeItemId } = useAppNavigationProps()

  useNavigationPerfAnalytics({ navItemsLoaded: navItems.length > 0 })

  if (!showAppNavigation) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return (
    <WithNavigation
      platformPlan={platformPlan || 'FUNDER'}
      orgName={orgName}
      navItems={navItems}
      logo={logo}
      accountItems={accountItems}
      activeItemId={activeItemId}
      isFunder={isFunder}
    >
      {children}
    </WithNavigation>
  )
}
